

































































































import Vue from "vue";
import ApiService from "@/services/ApiService";
import { MLFieldOptions } from "@/constants/ML";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

// import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
export default Vue.extend({
  name: "ApplyMLModal",
  components: {
    // OrgSelectionAdmin,
    VueJsonPretty
  },
  data() {
    return {
      testRecipient: "",
      MLFieldOptionsObj: {},
      showPreviewCount: false,
      loadingPreview: false,
      previewData: [],
      previewFields: [],
      availablePreviewFields: [],
      form: {
        name: "",
        ml_model_id: null,
        limit_rows: null,
        query_json: [],
        step_journeys_upload_id: null,
        model_id: null
      },
      availableModels: [],
      mlModelsPreview: [],
      loading: false,
      responseInfo: {
        status: null,
      },
      showJsonModal: false,
      jsonData: {}
    };
  },
  computed: {
    selectedField() {
      return "%" + this.field + "%";
    },
    fieldOptions() {
      return MLFieldOptions;
    },
  },
  props: {
    id: {
      type: Number || String,
      required: false,
    },
    isLaunchModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getPreviewData() {
      this.loadingPreview = true;
      // this.$refs["ML_Form"].validate();
      const payload = {
        ...this.form,
        limit: this.limit ?? null,
        preview_models: this.mlModelsPreview
      };
      ApiService.mlApi
        .previewPredict(payload)
        .then((resp) => {
          this.showPreviewCount = true;
          if (resp.data.data.length === 0) {
            // this.previewFields = [];

            this.previewData = [];
            return;
          }
          this.previewData = resp.data.data;
          this.previewFields = resp.data.fields;
        })
        .finally(() => {
          this.loadingPreview = false;
        });
    },
    addRule() {
      this.form.query_json.push({
        comparison: "=",
      });
      this.$forceUpdate();
    },
    removeRule(index) {
      this.form.query_json.splice(index, 1);
    },
    closeModal() {
      this.close();
    },
    applyML() {
      ApiService.mlApi.applyModel(this.form).then((resp) => {
        this.id = resp.data;
        this.$notify.info({
          title: "Saved",
          message: "Good things just happened!",
        });
      });
    },
    getMlModels() {
      ApiService.mlApi.getMlModels().then((resp) => {
        this.availableModels = resp.data.filter((itm) => itm.trained_status == 'TRAINED');
      });
    },
    close() {
      this.$emit("close");
    },
    async copyText(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.$notify.info({
          title: "Copied",
        });
      } catch ($e) {
        alert("Cannot copy");
      }
    },
  },
  // beforeUnmount() {
  //   if (this.timeout) {
  //     clearTimeout(this.timeout);
  //   }
  // },
  mounted() {
    this.MLFieldOptionsObj = MLFieldOptions.reduce(
      (obj, cur) => ({ ...obj, [cur.value]: cur }),
      {}
    );
    this.getMlModels();
    if (this.id != 0) {
      ApiService.mlApi.getSingleMl(this.id).then((resp) => {
        const obj = resp.data;
        // this.form = obj;
        this.form.id = this.id;
        this.form.name = obj.name;
        this.form.estimator = obj.estimator;
        this.form.tags = obj.tags ? obj.tags : [];
        this.form.description = obj.description;
        this.form.date = obj.date;
        this.form.holdout = obj.holdout;
        this.form.organization_ids = obj.organization_ids
          ? obj.organization_ids
          : [];
        // this.form.organization_ids = [];
        this.form.query_json = obj.query_json;
        this.form.selection_type =
          obj.selection_type == "BLACKLIST" ? true : false;
        // this.form.custom_rules = JSON.parse(obj.custom_rules);
        this.form.selected_fields_json = obj.selected_fields_json;
        this.form.target_field = obj.target_field;
        // this.form.extra_options = JSON.parse(obj.extra_options);
        this.$forceUpdate();
        this.showSchoolFilter = true;
      });
    }

    this.showSchoolFilter = true;
  },
});
